import useAccountData from 'hooks/useAccountData';
import { AccessLevel } from 'models/Company';
import { GetProductConfigurationsResponse } from 'models/WebShop';
import React, { createContext, useState, useContext } from 'react';
import { webShopService } from 'services/Services';


interface ProductConfigurationContextType {
  productConfigurationsByCompany: { [companyId: string]: GetProductConfigurationsResponse };
  fetchProductConfigurations: (companyId: string) => Promise<void>;
}

const ProductConfigurationContext = createContext<ProductConfigurationContextType | undefined>(undefined);

export const ProductConfigurationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [productConfigurationsByCompany, setProductConfigurationsByCompany] = useState<{ [companyId: string]: GetProductConfigurationsResponse }>({});
  const { getCurrentCompany } = useAccountData();

  const fetchProductConfigurations = async (companyId: string) => {

    const company = await getCurrentCompany(companyId);

    if (company === null) {
      setProductConfigurationsByCompany(prev => ({
        ...prev,
        [companyId]: {},
      }));
    }
    else {     
      const response = await webShopService.getProductConfigurations(companyId);
      if (response) {
        setProductConfigurationsByCompany(prev => ({
          ...prev,
          [companyId]: response,
        }));
      }
    }
  };

  return (
    <ProductConfigurationContext.Provider value={{ productConfigurationsByCompany, fetchProductConfigurations }}>
      {children}
    </ProductConfigurationContext.Provider>
  );

};


export const useProductConfiguration = () => {
  const context = useContext(ProductConfigurationContext);
  if (!context) {
    throw new Error('useProductConfiguration must be used within an OrdersProvider');
  }
  return context;
};

